import { DocumentContext } from '@/pages/document/single/types'
import { shallowRef } from 'vue'
import { openDialog } from '@/dialog'
import {
  documentRelationDelete,
  documentRelationList,
} from '@/requests/document'

export function useRelation({ documentId }: DocumentContext) {
  const relationList = shallowRef<any[]>([])

  const getRelationList = () => {
    return documentRelationList(documentId.value).then(res => {
      relationList.value = res
    })
  }

  const relationCreate = () => {
    openDialog({
      name: 'DocumentRelation',
      action: 'create',
      dialogData: {
        docTypeDocumentId: documentId.value,
        existRelationDocumentIds: relationList.value.map(d => d.id),
      },
      params: {
        cb: relations => {
          relationList.value = relations
        },
      },
    })
  }

  const relationDelete = (relationDocumentId: number) => {
    return documentRelationDelete(documentId.value, relationDocumentId).then(
      () => {
        relationList.value = relationList.value.filter(
          d => d.id !== relationDocumentId
        )
      }
    )
  }

  return { relationList, getRelationList, relationCreate, relationDelete }
}
